import * as Yup from 'yup';
import { TFunction } from 'i18next';
import {
  IChangeEmail,
  IChangeNameSurname,
  IChangePassword,
  IChangeJobTitle,
  IChangeCompanyLocation,
  IChangeCompanySize
} from 'core/interface/settings';

const emailValues: IChangeEmail = {
  email: ''
};

const nameSurnameValues: IChangeNameSurname = {
  first_name: '',
  last_name: ''
};

const jobTitleValues: IChangeJobTitle = {
  job_title: ''
};

const companyLocationValues: IChangeCompanyLocation = {
  city: {
    id: 0,
    display_name: ''
  }
};

const companySizeValues: IChangeCompanySize = {
  size: 1
};

const passwordValues: IChangePassword = {
  oldPassword: '',
  newPassword: '',
  repeatPassword: ''
};

const nameSurnameValidation = (t: TFunction) => {
  return Yup.object({
    first_name: Yup.string()
      .trim()
      .min(3, `${t('least')} 3 ${t('characters')}`)
      .required(t('required')),
    last_name: Yup.string()
      .trim()
      .min(3, `${t('least')} 3 ${t('characters')}`)
      .required(t('required'))
  });
};

const jobTitleValidation = (t: TFunction) => {
  return Yup.object({
    job_title: Yup.string()
      .trim()
      .min(2, `${t('least')} 2 ${t('characters')}`)
      .max(50, `${t('less_than')} 50 ${t('characters')}`)
      .required(t('required'))
  });
};

const emailValidation = (t: TFunction) => {
  return Yup.object({
    email: Yup.string().required(t('required'))
  });
};

const passwordValidation = (t: TFunction) => {
  return Yup.object().shape({
    oldPassword: Yup.string().trim(),
    newPassword: Yup.string()
      .trim()
      .when('oldPassword', {
        is: (oldPassword: string) => oldPassword && oldPassword.length > 0,
        then: (schema) => schema.required(t('required')),
        otherwise: (schema) => schema
      }),
    repeatPassword: Yup.string()
      .trim()
      .when('oldPassword', {
        is: (oldPassword: string) => oldPassword && oldPassword.length > 0,
        then: (schema) =>
          schema
            .required(t('required'))
            .oneOf([Yup.ref('newPassword')], t('Passwords do not match')),
        otherwise: (schema) => schema
      })
  });
};

const companyLocationValidation = (t: TFunction) => {
  return Yup.object({
    city: Yup.object().shape({
      id: Yup.number().required(t('required')),
      display_name: Yup.string().required(t('required'))
    })
  });
};

const companySizeValidation = (t: TFunction) => {
  return Yup.object({
    size: Yup.number().min(1, t('required')).required(t('required'))
  });
};

export {
  emailValues,
  nameSurnameValues,
  jobTitleValues,
  companyLocationValues,
  companySizeValues,
  passwordValues,
  emailValidation,
  passwordValidation,
  nameSurnameValidation,
  jobTitleValidation,
  companyLocationValidation,
  companySizeValidation
};
